<template>
  <div>
    <el-tag v-if="entity.ipType == Enum.IpType.自费" size="mini" type="warning" hit effect="light" class="right-pad">{{ entity.ipType }}</el-tag>
    <el-tag v-if="entity.ipType == Enum.IpType.医保" size="mini" type="success" hit effect="light" class="right-pad">{{ entity.ipType }}</el-tag>
    <el-tag v-if="entity.ipType == Enum.IpType.医保工伤" size="mini" type="danger" hit effect="light" class="right-pad">{{ entity.ipType }}</el-tag>
    <el-tag v-if="(entity.balance || 0) <= 0" size="mini" type="danger" hit effect="light" class="right-pad">欠</el-tag>
    <el-tag v-if="entity.ifBaby" size="mini" type="primary" hit effect="dark" class="right-pad" title="新生儿">婴</el-tag>
    <el-tag v-if="entity.patientAllergyDrugs" size="mini" type="primary" hit effect="light" class="right-pad" :title="entity.patientAllergyDrugs">敏</el-tag>
    <el-tag v-if="entity.criticalLevel == '濒危'" size="mini" type="danger" hit effect="dark" class="right-pad" title="濒危">危</el-tag>
    <el-tag v-if="entity.criticalLevel == '危重'" size="mini" type="warning" hit effect="dark" class="right-pad" title="危重">重</el-tag>
    <el-tag v-if="entity.ifBillingEnd" size="mini" type="success" hit effect="light" class="right-pad" title="出院挂账">出</el-tag>
    <el-tag v-if="!!entity.daysAfterSurgery" size="mini" type="warning" hit effect="light" class="right-pad" :title="`术后${entity.daysAfterSurgery}天`">术</el-tag>
    <el-tag v-if="entity.nursingGrade == '特级护理'" size="mini" type="info" hit effect="dark" class="right-pad" style="border-radius: 10px; min-width: 25px; text-align: center" title="特级护理">特</el-tag>
    <el-tag v-if="entity.nursingGrade == '一级护理'" size="mini" type="info" hit effect="dark" class="right-pad" style="border-radius: 10px; min-width: 25px; text-align: center" title="一级护理">I</el-tag>
    <el-tag v-if="entity.nursingGrade == '二级护理'" size="mini" type="info" hit effect="dark" class="right-pad" style="border-radius: 10px; min-width: 25px; text-align: center" title="二级护理">II</el-tag>
    <el-tag v-if="entity.nursingGrade == '三级护理'" size="mini" type="info" hit effect="dark" class="right-pad" style="border-radius: 10px; min-width: 25px; text-align: center" title="三级护理">III</el-tag>
  </div>
</template>
<script>
  import { mapGetters } from "sw-hic";
  export default {
    name: "hic-hospitalization-tags",
    props: {
      entity: {
        type: Object,
        default: () => {},
      },
    },
    computed: {
      ...mapGetters(["Enum"]),
    },
  };
</script>
